<div class="mb-6 flex items-center justify-between">
  <h1 class="textTabsColor text-2xl font-bold" i18n="@@breadcrumbRouteInstances">Route Instances</h1>
</div>

<app-route-instances-filter
  [filters]="filters()"
  (toggleSortOrder)="toggleSortOrder()"
  (resetFilters)="resetFilters()"
  (applyFilters)="applyFilters($event)" />

<app-route-instances-table
  [instances]="instances()"
  [state]="state()"
  [currentPage]="currentPage()"
  [totalItems]="totalItems()"
  [itemsPerPage]="itemsPerPage()"
  [totalPages]="totalPages"
  [isFiltersApplied]="isFiltersApplied()"
  [startRouteInstanceError]="startRouteInstanceError()"
  [closeStartDialog]="closeStartDialog()"
  (pageChange)="onPageChange($event)"
  (pageSizeChange)="onPageSizeChange($event)"
  (rowClick)="navigateToDetails($event)"
  (startRouteInstance)="onStartRouteInstance($event)"
  (cancelRouteInstance)="onCancelRouteInstance($event)"
  [cancelRouteError]="cancelRouteError()" />
